import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Table } from '@robocorp/components';
import { useParams } from '~/hooks';
import { CellRunDetails } from '~/components';

interface Props {
  processId: string;
  processRunId: string | null;
  processRunNo?: number;
  processName?: string;
}

export const WorkDataTableProcessRunCell: React.FC<Props> = ({
  processId,
  processRunId,
  processRunNo,
  processName,
}) => {
  const { organizationShortName, workspaceShortName } = useParams<
    'organizationShortName' | 'workspaceShortName'
  >();

  const detailsLink = useMemo(
    () =>
      `/${organizationShortName}/${workspaceShortName}/processes/${processId}/runs/${processRunId}`,
    [organizationShortName, workspaceShortName, processId, processRunId],
  );

  if (!processRunId || !processRunNo) return <Table.Cell>-</Table.Cell>;

  return (
    <Table.Cell maxWidth={400} controls>
      <Link as={RouterLink} to={detailsLink} target="_blank">
        <CellRunDetails text={processName} subNumber={processRunNo} />
      </Link>
    </Table.Cell>
  );
};
